import React from "react";
import { Fade } from "react-reveal";
import Banff from "../assets/images/Banff.jpg";
import MountainTop from "../assets/images/MountainTop.jpg";
import Skywalk from "../assets/images/Skywalk.jpg";
import TrishaGraduation from "../assets/images/TrishaGraduation.jpg";
import TrishaGraduation1 from "../assets/images/TrishaGraduation1.jpg";
import TrishaGraduation3 from "../assets/images/TrishaGraduation3.jpg";
import "./Page.scss";

const Travels = () => {
  return (
    <div className="page-container">
      <Fade bottom duration={1000} distance="20px">
        <div className="page-header">
          <h1 className="page-title">Travels</h1>
        </div>
      </Fade>
      
      <Fade bottom duration={1000} distance="20px" delay={200}>
        <div className="page-content">
          <div className="travel-section">
            <div className="travel-card">
              <div className="photo-stack">
                <div className="photo-stack-item photo-1">
                  <img src={Banff} alt="Banff National Park" />
                </div>
                <div className="photo-stack-item photo-2">
                  <img src={MountainTop} alt="Mountain Top Adventure" />
                </div>
                <div className="photo-stack-item photo-3">
                  <img src={Skywalk} alt="Skywalk Experience" />
                </div>
              </div>
              <div className="travel-content">
                <h2>Family Trip to Banff – Canada</h2>
                <p>A deserving Master's graduation celebration spent with family in the stunning wintery mountains of Banff. We explored the serene beauty of Lake Louise, enjoyed hikes through the snow-covered trails, and took in the breathtaking views from the Skywalk. Above all, it was a special time to celebrate milestones and create lasting memories together.</p>
                <div className="travel-stats">
                  <div className="stat">
                    <span className="stat-number">May 2025</span>
                    <span className="stat-label">Graduation Celebration</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <div className="travel-section">
            <div className="travel-card graduation-card">
              <div className="travel-content">
                <h2>Trisha Bachelors Graduation at JHU</h2>
                <p>Celebrating the completion of my Bachelor's degree in Computer Science and Biomedical Engineering at Johns Hopkins University. A momentous occasion marking years of dedication, hard work, and academic achievement in the field of biomedical engineering and computational biology.</p>
                <div className="travel-stats">
                  <div className="stat">
                    <span className="stat-number">May 2023</span>
                    <span className="stat-label">Timeline</span>
                  </div>
                </div>
              </div>
              <div className="photo-stack graduation-photos">
                <div className="photo-stack-item photo-1">
                  <img src={TrishaGraduation} alt="Trisha Graduation" />
                </div>
                <div className="photo-stack-item photo-2">
                  <img src={TrishaGraduation1} alt="Trisha Graduation 1" />
                </div>
                <div className="photo-stack-item photo-3">
                  <img src={TrishaGraduation3} alt="Trisha Graduation 3" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </Fade>
    </div>
  );
};

export default Travels;


